const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

export type ExportTaskStatus = 'PENDING' | 'PROCESSING' | 'DONE' | 'ERROR';

export type ExportTask = {
  id: string;
  status: ExportTaskStatus;
  fileUrl?: string;
  errorMessage?: string;
}

const getAdminApiUrl = () => {
  if (!adminApiUrl) {
    throw new Error('Не указан REACT_APP_ADMIN_API_URL');
  }

  return adminApiUrl;
};

const requestExportTask = async (url: string, init?: RequestInit): Promise<ExportTask> => {
  const response = await fetch(url, init);

  if (!response.ok) {
    const error = await response.json().catch(() => null);
    const message = Array.isArray(error?.message) ? error.message.join(', ') : error?.message;

    throw new Error(message || 'Не удалось выполнить запрос экспорта');
  }

  return response.json();
};

const getFileNameFromContentDisposition = (contentDisposition: string | null) => {
  if (!contentDisposition) {
    return null;
  }

  const utfFileName = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];

  if (utfFileName) {
    return decodeURIComponent(utfFileName);
  }

  return contentDisposition.match(/filename="?([^"]+)"?/i)?.[1] || null;
};

export const createExportTask = (subcategoryId: string, path: string) => requestExportTask(`${getAdminApiUrl()}/export`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({
    subcategoryId,
    path,
  }),
});

export const getExportTaskStatus = (taskId: string) => requestExportTask(`${getAdminApiUrl()}/export/${taskId}/status`);

export const getExportTaskDownloadUrl = (taskId: string) => `${getAdminApiUrl()}/export/${taskId}/download`;

export const downloadExportTaskFile = async (taskId: string) => {
  const response = await fetch(getExportTaskDownloadUrl(taskId))
    .catch(() => {
      throw new Error('Архив сформирован, но ссылка для скачивания недоступна');
    });

  if (!response.ok) {
    const error = await response.json().catch(() => null);
    const message = Array.isArray(error?.message) ? error.message.join(', ') : error?.message;

    throw new Error(message || 'Не удалось скачать архив');
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = getFileNameFromContentDisposition(response.headers.get('Content-Disposition')) || 'export.zip';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url));
};
